interface Input {
  key?: number;
  userVersion: number;
}
export class InputUtil {
  static isInputEqual(prev: Input, current: Input): boolean {
    return prev.key === current.key && prev.userVersion === current.userVersion;
  }
}
